// extracted by mini-css-extract-plugin
export default {"Box":"row-reorder-sash-module__Box--ImzXE","Octicon":"row-reorder-sash-module__Octicon--pe9sQ"};